import { render, staticRenderFns } from "./Ramp.vue?vue&type=template&id=47b658b2"
import script from "./Ramp.vue?vue&type=script&lang=js"
export * from "./Ramp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports